import { ActionTypes } from 'actions/types';
import { objType }     from 'types';


export const initialIdleTimeState: objType = {
  idleTime: 0
}

const idleTimeReducer = (state = initialIdleTimeState, action: ActionTypes) => {

switch (action.type) {


case 'SET_IDLE_TIME':
  {
    return { idleTime: action.payload }
  }

// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};


export { idleTimeReducer };
